module.exports = __webpack_public_path__ + "img/empty-search-result.f60048b5.svg";